
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [ngClass]="{'general-disabled':isMigrationActive}">
  <div class="row mt-2">
    <div class="col-12">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row mt-2" *ngIf="warningMessage">
    <div class="col-12">
      <div class="alert alert-warning"><span>{{ warningMessage }}</span></div>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Setup Project Groups</p>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="projectHasCustomer">
    <div class="col table-card">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="filteredGroups.length" (onChange)="onListControlsChange($event)">
        <div class="btn-group float-right">
          <button class="btn btn-outline-secondary" [disabled]="!k2GroupsImportableCount || !workflowTargetInfo.correctRole" type="button" (click)="addK2Group()">Import K2 Group</button>
          <button class="btn btn-outline-secondary" [disabled]="!workflowTargetInfo.correctRole" type="button" (click)="addAreaGroup()">Add Row</button>
        </div>
      </list-controls>
      <fieldset [disabled]="!workflowTargetInfo.correctRole">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="required">Area</th>
              <th>Group</th>
              <th>Usage</th>
              <th *ngIf="!isEmea">Toner</th>
              <th *ngIf="!isEmea">Ink</th>
              <th *ngIf="isEmea">EMEA Toner-Ink</th>
              <th>Longlife</th>
              <th>Maintenance</th>
              <th>Fasteners</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let g of displayedGroups; let i = index">
              <td>
                <input class="form-control" type="text" [(ngModel)]="g.areaName" maxlength="75" [disabled]="!g.allowEdit" (change)="changed(g)" *ngIf="!g.areaDisabled">
                <input class="form-control" type="text" [(ngModel)]="g.areaName" maxlength="75" [disabled]="!g.allowEdit" (change)="changed(g)" style="background: #FFCCCC;" *ngIf="g.areaDisabled"><span class="d-block" *ngIf="g.differsFromK2" style="color: red;">Differs from K2</span><span class="d-block" *ngIf="g.areaNameRequired" style="color: red;">Area is required</span><span class="d-block" *ngIf="g.areaDisabled" style="color: red;">Area is disabled in K2</span>
              </td>
              <td>
                <input class="form-control" type="text" [(ngModel)]="g.groupName" maxlength="75" [disabled]="!g.allowEdit" (change)="changed(g)" *ngIf="!g.areaDisabled &amp;&amp; !g.groupDisabled">
                <input class="form-control" type="text" [(ngModel)]="g.groupName" maxlength="75" [disabled]="!g.allowEdit" (change)="changed(g)" style="background: #FFCCCC;" *ngIf="g.areaDisabled || g.groupDisabled"><span class="d-block" *ngIf="g.groupNameRequired" style="color: red;">Group is required</span><span class="d-block" *ngIf="g.groupDisabled &amp;&amp; !g.areaDisabled" style="color: red;">Group is disabled in this area</span><span class="d-block" *ngIf="g.duplicate" style="color: red;">Duplicate area/group entry</span><span class="d-block" *ngIf="g.disableEditReasons" style="color: red;">Editing is disabled 
                  <button class="btn btn-primary btn-circle-sm oi oi-question-mark" (click)="showAsmDisableReason(g, 'groupDisable')"></button></span>
                <div *ngIf="g.asmCheckedDate">
                  <label class="mb-0 mt-3">Earliest ASM Date</label>
                  <input class="form-control" type="text" [(ngModel)]="g.asmCheckedDate" disabled>
                </div>
              </td>
              <td>
                <div class="form-check">
                  <input class="form-check-input" [disabled]="!!g.disableEditReasons" type="checkbox" [(ngModel)]="g.doUsageCollection" (change)="usageCollectionChanged(g)" autoLinkToLabel>
                  <label class="form-check-label">Enable</label>
                </div>
              </td>
              <td *ngIf="!isEmea">
                <div class="form-check" [hidden]="!g.doUsageCollection">
                  <input class="form-check-input" [disabled]="!!g.disableEditReasons" type="checkbox" [(ngModel)]="g.doTonerMonitoring" (change)="change(g)" autoLinkToLabel>
                  <label class="form-check-label">Monitor</label>
                </div>
                <div class="form-check" [hidden]="!g.doUsageCollection || !g.doTonerMonitoring">
                  <input class="form-check-input" [disabled]="g.disableEditReasons || !g.hasConsumableAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" type="checkbox" [(ngModel)]="g.doTonerAutoOrder" (change)="change(g)" autoLinkToLabel>
                  <label class="form-check-label">ASM 
                    <button class="btn btn-primary btn-circle-sm oi oi-question-mark" *ngIf="!g.hasConsumableAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" (click)="showAsmDisableReason(g, 'consumable')"></button>
                  </label>
                </div>
              </td>
              <td *ngIf="!isEmea">
                <div class="form-check" [hidden]="!g.doUsageCollection">
                  <input class="form-check-input" [disabled]="!!g.disableEditReasons" type="checkbox" [(ngModel)]="g.doInkMonitoring" (change)="change(g)" autoLinkToLabel>
                  <label class="form-check-label">Monitor</label>
                </div>
                <div class="form-check" [hidden]="!g.doUsageCollection || !g.doInkMonitoring">
                  <input class="form-check-input" [disabled]="g.disableEditReasons || !g.hasConsumableAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" type="checkbox" [(ngModel)]="g.doInkAutoOrder" (change)="change(g)" autoLinkToLabel>
                  <label class="form-check-label">ASM 
                    <button class="btn btn-primary btn-circle-sm oi oi-question-mark" *ngIf="!g.hasConsumableAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" (click)="showAsmDisableReason(g, 'consumable')"></button>
                  </label>
                </div>
              </td>
              <td *ngIf="!isEmea">
                <div class="form-check" [hidden]="!g.doUsageCollection">
                  <input class="form-check-input" [disabled]="!!g.disableEditReasons" type="checkbox" [(ngModel)]="g.doPrintHeadMonitoring" (change)="change(g)" autoLinkToLabel>
                  <label class="form-check-label">Monitor</label>
                </div>
                <div class="form-check" [hidden]="!g.doUsageCollection || !g.doPrintHeadMonitoring">
                  <input class="form-check-input" [disabled]="g.disableEditReasons || !g.hasConsumableAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" type="checkbox" [(ngModel)]="g.doPrintHeadAutoOrder" (change)="change(g)" autoLinkToLabel>
                  <label class="form-check-label">ASM 
                    <button class="btn btn-primary btn-circle-sm oi oi-question-mark" *ngIf="!g.hasConsumableAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" (click)="showAsmDisableReason(g, 'consumable')"></button>
                  </label>
                </div>
              </td>
              <td *ngIf="!isEmea">
                <div class="form-check" [hidden]="!g.doUsageCollection">
                  <input class="form-check-input" [disabled]="!!g.disableEditReasons" type="checkbox" [(ngModel)]="g.doMaintenanceMonitoring" (change)="change(g)" autoLinkToLabel>
                  <label class="form-check-label">Monitor</label>
                </div>
                <div class="form-check" [hidden]="!g.doUsageCollection || !g.doMaintenanceMonitoring">
                  <input class="form-check-input" [disabled]="g.disableEditReasons || !g.hasServiceAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" type="checkbox" [(ngModel)]="g.doMaintenanceAutoOrder" (change)="change(g)" autoLinkToLabel>
                  <label class="form-check-label">ASM 
                    <button class="btn btn-primary btn-circle-sm oi oi-question-mark" *ngIf="!g.hasServiceAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" (click)="showAsmDisableReason(g, 'maintenance')"></button>
                  </label>
                </div>
              </td>
              <td *ngIf="!isEmea">
                <div class="form-check" [hidden]="!g.doUsageCollection">
                  <input class="form-check-input" [disabled]="!!g.disableEditReasons" type="checkbox" [(ngModel)]="g.doFastenerMonitoring" (change)="change(g)" autoLinkToLabel>
                  <label class="form-check-label">Monitor</label>
                </div>
                <div class="form-check" [hidden]="!g.doUsageCollection || !g.doFastenerMonitoring">
                  <input class="form-check-input" [disabled]="g.disableEditReasons || !g.hasConsumableAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" type="checkbox" [(ngModel)]="g.doFastenerAutoOrder" (change)="change(g)" autoLinkToLabel>
                  <label class="form-check-label">ASM 
                    <button class="btn btn-primary btn-circle-sm oi oi-question-mark" *ngIf="!g.hasConsumableAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" (click)="showAsmDisableReason(g, 'consumable')"></button>
                  </label>
                </div>
              </td>
              <td *ngIf="isEmea">
                <div class="form-check" [hidden]="!g.doUsageCollection">
                  <input class="form-check-input" [disabled]="!!g.disableEditReasons" type="checkbox" [(ngModel)]="g.doTonerMonitoring" (change)="emeaDataChanged(g)" autoLinkToLabel>
                  <label class="form-check-label">Monitor</label>
                </div>
              </td>
              <td *ngIf="isEmea">
                <div class="form-check" [hidden]="!g.doUsageCollection">
                  <input class="form-check-input" [disabled]="g.disableEditReasons || !g.hasConsumableAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" type="checkbox" [(ngModel)]="g.doPrintHeadMonitoring" (change)="emeaDataChanged(g)" autoLinkToLabel>
                  <label class="form-check-label">Monitor </label>
                </div>
              </td>
              <td *ngIf="isEmea">
                <div class="form-check" [hidden]="!g.doUsageCollection">
                  <input class="form-check-input" [disabled]="!!g.disableEditReasons" type="checkbox" [(ngModel)]="g.doMaintenanceMonitoring" (change)="legacyMaintenanceCheckboxChanged(g)" autoLinkToLabel>
                  <label class="form-check-label">Monitor
                    <button class="btn btn-primary btn-circle-sm oi oi-question-mark" *ngIf="!g.hasConsumableAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" (click)="showAsmDisableReason(g, 'consumable')"></button>
                  </label>
                </div>
              </td>
              <td *ngIf="isEmea">
                <div class="form-check" [hidden]="!g.doUsageCollection">
                  <input class="form-check-input" [disabled]="g.disableEditReasons || !g.hasConsumableAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" type="checkbox" [(ngModel)]="g.doFastenerMonitoring" (change)="emeaDataChanged(g)" autoLinkToLabel>
                  <label class="form-check-label">Monitor 
                    <button class="btn btn-primary btn-circle-sm oi oi-question-mark" *ngIf="!g.hasConsumableAddressUploader || !g.hasVerificationContactUploader || !g.hasExceptionContactUploader" (click)="showAsmDisableReason(g, 'consumable')"></button>
                  </label>
                </div>
              </td>
              <td>
                <button class="btn btn-outline-danger oi oi-trash" *ngIf="!g.assetsRelated" type="button" (click)="removeAreaGroup(g)"></button><span *ngIf="g.assetsRelated">Assets Related</span>
              </td>
            </tr>
            <tr *ngIf="!groups?.length">
              <td colspan="8">
                <p class="text-center empty-table-message">There are no Groups to display.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </fieldset>
    </div>
  </div>
</div>